import React, {FC, useEffect, useState} from "react";
import shopApi from "../../../api/shop";
import WidgetSmartSearch from "./SmartSearchComponents/WidgetSmartSearch";
import SmartSearchStepOne from "./SmartSearchComponents/SmartSearchStepOne";
import NewSearch from "./SmartSearchComponents/NewSearch";
import {useDispatch, useSelector} from "react-redux";
import {IState} from "../../../types/state";
import {useRouter} from "next/router";
import {setSmartSearchUrl} from "../../../store/smart-search";
import ProductCard from "../../ForCWV/Products/ProductCard";
import {TranslationsType} from "../../../types/homePageTypes";


interface ISmartSearch {
    rootId: number
    translationsData: TranslationsType,
    selectedCurrItems: {
        selectedCurrCode: string;
        selectedCurrRate: string;
        selectedCurrSymbol: string
    };
    selectedLocale: string,
    dbName: string
    domain: string;
    showWishlist: boolean
    showCart: boolean
}

const CustomSmartSearch: FC<ISmartSearch> = (
    {
        rootId,
        translationsData,
        selectedLocale,
        selectedCurrItems,
        dbName,
        domain,
        showWishlist,
        showCart
    }
) => {
    const {locale} = useRouter()
    const [step, setStep] = useState(0)
    const [catData, setCatData] = useState<any>([])
    const [catData2, setCatData2] = useState<any>([])
    const [catData3, setCatData3] = useState<any>([])
    const [catData4, setCatData4] = useState<any>([])

    const [step2Id, setStep2Id] = useState<any | undefined>()
    const [step3Id, setStep3Id] = useState<any | undefined>()
    const [step4Id, setStep4Id] = useState<any | undefined>()
    const [lastStep, setLastStep] = useState<any | undefined>()

    const [products, setProducts] = useState([])

    const dispatch = useDispatch()
    const customer = useSelector((state: IState) => state.customer)


    useEffect(() => {
        dispatch(setSmartSearchUrl(window.location.pathname))
        getCategoriesRoot(rootId, locale)
        setStep(1)
    }, [locale])

    useEffect(() => {
        if (step2Id && step === 1) {
            getChildCategories(step2Id.id, locale, setCatData2)
            setStep(2)
            setStep3Id(null)
        }
        if (step3Id && step === 2) {
            getChildCategories(step3Id.id, locale, setCatData3)
            setStep(3)
            setStep4Id(null)
        }
        if (step4Id && step === 3) {
            getChildCategories(step4Id.id, locale, setCatData4)
            setStep(4)
        }
        if (lastStep && step === 4) {
            const options = {
                catID: lastStep.id,
                slug: lastStep.slug,
                locale: locale,
                domain: domain,
                dbName: dbName,
            }
            getProducts(options, setProducts)
            setStep(5)
        }

    }, [step2Id, step3Id, step4Id, lastStep, locale])


    const getCategoriesRoot = async (rootId: number, locale: any) => {
        const rootCat = await shopApi.getSmartSearchCats(locale, rootId);
        setCatData(rootCat)
    }

    const getChildCategories = async (id: number | undefined, locale: any, setCallback: ((arg0: any) => void) | undefined) => {
        const rootCat = await shopApi.getSmartSearchCats(locale, id)

        if (setCallback) {
            setCallback(rootCat)
        }
    }

    const getProducts = async (options: {
        catID: number | string,
        slug: string,
        locale: string | undefined
        domain: string,
        dbName: string,
    }, setCallback: ((arg0: any) => void) | undefined) => {

        const res = await shopApi.getProductsBySmartSearch(options)
        if (setCallback) {
            setCallback([...res.data])
        }
    }

    const productsListItems = products?.map((product, index) => {
        return (
            <React.Fragment key={index}>
                <div className={'products-list__item search-products-card'}>
                    <ProductCard
                        product={product}
                        dbName={dbName}
                        translationsData={translationsData}
                        backOrderValue=""
                        selectedCurrItems={selectedCurrItems}
                        selectedLocale={selectedLocale}
                        showWishlist={showWishlist}
                        showCart={showCart}
                    />
                </div>
            </React.Fragment>
        )
    })


    const renderSteps = () => {

        if (step <= 1) {
            return <SmartSearchStepOne
                listItem={catData}
                setStep2Id={setStep2Id}
                dbName={dbName}
                domain={domain}
                step2Id={step2Id}
            />
        } else if (step >= 2 && step <= 4) {
            return <>

                <div className="smart-search-page-second">
                    <div className="new-search-feature-top">
                        <NewSearch translationsData={translationsData}/>
                        <WidgetSmartSearch
                            setStep={setStep}
                            forStep={1}
                            listItem={catData}
                            setStepId={setStep2Id}
                            stepId={step2Id}
                        />
                    </div>

                    <div className="smart-search-optional-steps">


                        <WidgetSmartSearch
                            setStep={setStep}
                            defaultMessage={"step 1"}
                            title={translationsData.TitleOne}
                            forStep={2}
                            listItem={catData2}
                            setStepId={setStep3Id}
                            stepId={step3Id}
                        />
                        <WidgetSmartSearch
                            setStep={setStep}
                            defaultMessage={"step 2"}
                            title={translationsData.TitleTwo}
                            forStep={3}
                            disabled={step <= 2}
                            listItem={catData3}
                            setStepId={setStep4Id}
                            stepId={step4Id}
                        />
                        <WidgetSmartSearch
                            setStep={setStep}
                            defaultMessage={"step 3"}
                            title={translationsData.TitleThree}
                            forStep={4}
                            disabled={step <= 3}
                            listItem={catData4}
                            setStepId={setLastStep}
                            stepId={lastStep}
                        />
                    </div>
                </div>
            </>
        } else {
            return <>
                <div>
                    <NewSearch translationsData={translationsData}/>
                </div>
                <div className="products-view__content smart-search-products">
                    <div className="products-list">
                        <div className="products-list__body">{productsListItems}</div>
                    </div>
                </div>
            </>
        }
    }

    return <>
        <div className="smart-search-wrapper">
            <div className="smart-search">
                {renderSteps()}
            </div>
        </div>
    </>
};


export default CustomSmartSearch